import config from '../config';
import NoUserIcon from '../images/no-user.svg';
import NoImage from '../images/noimage-placeholder.png';

const { apiHost } = config;

interface Options {
  urn?: string;
}

export function getProfilePic(photoToken?: string) {
  if (!photoToken) return NoUserIcon as string;

  if (/^https:\/\//.test(photoToken)) return photoToken;

  return `${apiHost}/upload/info/thumbnail/${photoToken}`;
}

export function getImageUrl(attach?: any, options?: Options) {
  if (!(attach || {}).reference) {
    return NoImage;
  }

  return `${apiHost}/upload${options?.urn || '/info/original'}/${
    attach.reference
  }`;
}

export function getPropertyThumbnail(attaches: any[]) {
  return getImageUrl(getPropertyImages(attaches)?.[0], {
    urn: '/info/thumbnail',
  });
}

export function getPropertyImages(attaches: any[]) {
  const newAttaches = attaches || [];

  if (newAttaches.length === 0) {
    newAttaches.push({ uri: getImageUrl(), type: 'image' });
  }

  return newAttaches.filter((attach: any) => attach.type === 'image');
}
